import { createComponent } from '@carvana/merch-components';

export const Container = createComponent('div', {
  className:
    'row-span-2 m-auto flex h-[137px] w-[213px] items-center justify-center self-center rounded-lg bg-white shadow-[0px_28px_56px_0px_rgba(24,53,88,0.04),0px_8px_16px_0px_rgba(24,53,88,0.12)] m:h-auto m:w-[122px]'
});

export default function DefaultCardImage({ defaultLayout, altText, url }) {
  return (
    <Container className={defaultLayout ? '' : 'hidden'}>
      <img
        src={`${process.env.CVNA_APP_CDN_ASSETS_PATH}${url}`}
        alt={altText}
        className="rounded-lg"
      />
    </Container>
  );
}
